require('./openYoungTaxDataForm.scss');

// @ vendors
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const React = require('react');
const trim = require('lodash/string/trim');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ commons
const { RadioButton } = require('commonsComponents/radioButton');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { InputSafe } = require('commonsComponents/inputSafe');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKMessage } = require('commonsComponents/OKMessage');
const OKSelect = require('components/commons/OKSelect/OKSelect');

// @ actions
const openYoungTaxDataActions = require('actions/openYoungTaxData');

// @ constants
const { countryOptions, getTranslatedCountry } = require('constants/countries');
const TAXING_REASONS = require('constants/taxingReason');
const TAXING_REASONS_OPTIONS = Object.getOwnPropertyNames(TAXING_REASONS()).map(property =>
    ({value: property, label: TAXING_REASONS()[property]})
);

class OpenYoungTaxDataForm extends React.Component {

    constructor(props) {
        super(props);

        this.handleRadioButtonChange = this.handleRadioButtonChange.bind(this);
    }

    handleRadioButtonChange(value) {
        const {
            immOpenYoungTaxData,
            setField,
            toggleAddForm,
        } = this.props;
        // RadioButtonGroup component converts boolean to strings, so we use the next line to keep using a boolean
        const newValue = value === 'true';

        setField('hasTaxData', newValue);

        if (immOpenYoungTaxData.get('byId').size === 0) {
            toggleAddForm(true);
        }
    }

    buildForm(immEditableData) {
        const {
            handleCancel,
            handleSave,
            immOpenYoungTaxData,
            setFormField,
            validateFormField,
        } = this.props;
        const isEditing = !!immEditableData;
        const mandatoryFieldErrorMsg = formatText('openYoungTaxDataForm-openYoungTaxDataForm_mandatoryFieldError');
        const selectPlaceholder = formatText('openYoungTaxDataForm-openYoungTaxDataForm_combosPlaceholder');
        const selectNoResults = formatText('openYoungTaxDataForm-openYoungTaxDataForm_combosNotFound');
        const countryLabel = formatText('openYoungTaxDataForm-openYoungTaxDataForm_countryLabel');
        const reasonLabel = formatText('openYoungTaxDataForm-openYoungTaxDataForm_reasonLabel');
        const tinLabel = formatText('openYoungTaxDataForm-openYoungTaxDataForm_tinLabel');

        let availableCountries = countryOptions().filter(option =>
            Object.keys(immOpenYoungTaxData.get('byId').toJS()).indexOf(option.value) < 0
        );
        let id = 'new';
        let country = immOpenYoungTaxData.getIn(['editingById', 'new', 'country', 'value']);
        let countryErrorState = immOpenYoungTaxData.getIn(['editingById', 'new', 'country', 'isDirty']) && !immOpenYoungTaxData.getIn(['editingById', 'new', 'country', 'isValid']);
        let reason = immOpenYoungTaxData.getIn(['editingById', 'new', 'reason', 'value']);
        let reasonErrorState = immOpenYoungTaxData.getIn(['editingById', 'new', 'reason', 'isDirty']) && !immOpenYoungTaxData.getIn(['editingById', 'new', 'reason', 'isValid']);
        let tin = immOpenYoungTaxData.getIn(['editingById', 'new', 'tin', 'value']);
        let tinErrorState = immOpenYoungTaxData.getIn(['editingById', 'new', 'tin', 'isDirty']) && !immOpenYoungTaxData.getIn(['editingById', 'new', 'tin', 'isValid']);

        if (isEditing) {
            id = immEditableData.getIn(['country', 'value']);
            country = immEditableData.getIn(['country', 'value']);
            countryErrorState = immEditableData.getIn(['country', 'isDirty']) && !immEditableData.getIn(['country', 'isValid']);
            availableCountries = countryOptions().filter(option => option.value === country);
            reason = immEditableData.getIn(['reason', 'value']);
            reasonErrorState = immEditableData.getIn(['reason', 'isDirty']) && !immEditableData.getIn(['reason', 'isValid']);
            tin = immEditableData.getIn(['tin', 'value']);
            tinErrorState = immEditableData.getIn(['tin', 'isDirty']) && !immEditableData.getIn(['tin', 'isValid']);
        }

        return (
            <div>
                <div className="row open-young-tax-data-form__form">
                    <div className="col-xs-12 col-sm-6 col-lg-4 open-young-tax-data-form__form-field">
                        <OKSelect
                            disabled={isEditing}
                            errorMessage={mandatoryFieldErrorMsg}
                            errorState={countryErrorState}
                            label={countryLabel}
                            matchPos="start"
                            matchProp="label"
                            name="country"
                            noResultsText={selectNoResults}
                            onBlur={() => validateFormField(id, 'country')}
                            onChange={(optionObject) => setFormField(id, 'country', optionObject.value)}
                            options={availableCountries}
                            placeholder={selectPlaceholder}
                            searchable={true}
                            value={country}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-6 col-lg-4 open-young-tax-data-form__form-field">
                        <OKSelect
                            errorMessage={mandatoryFieldErrorMsg}
                            errorState={reasonErrorState}
                            name="reason"
                            label={reasonLabel}
                            matchPos="start"
                            matchProp="label"
                            noResultsText={selectNoResults}
                            onBlur={() => validateFormField(id, 'reason')}
                            onChange={(optionObject) => setFormField(id, 'reason', optionObject.value)}
                            options={TAXING_REASONS_OPTIONS}
                            placeholder={selectPlaceholder}
                            value={reason}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-6 col-lg-4 open-young-tax-data-form__form-field">
                        <InputSafe
                            errorMessage={mandatoryFieldErrorMsg}
                            errorState={tinErrorState}
                            label={tinLabel}
                            maxLength="30"
                            name="tin"
                            onBlur={() => validateFormField(id, 'tin')}
                            onChange={(event) => setFormField(id, 'tin', trim(event.target.value))}
                            type="text"
                            value={tin}
                        />
                    </div>
                </div>
                <div className="row open-young-tax-data-form__form-buttons">
                    <div className="col-xs-12 text-right">
                        <div className="open-young-tax-data-form__form-button">
                            <OKButton
                                modifier="ghost"
                                onClick={() => handleCancel(id, isEditing)}
                                size="small"
                            >
                                <FormattedText value="openYoungTaxDataForm-openYoungTaxDataForm_formCancelBtn" />
                            </OKButton>
                        </div>
                        <div className="open-young-tax-data-form__form-button">
                            <OKButton
                                modifier="secondary"
                                onClick={() => handleSave(id, isEditing)}
                                size="small"
                            >
                                <FormattedText value="openYoungTaxDataForm-openYoungTaxDataForm_formSaveButton" />
                            </OKButton>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    buildListItem(immItem) {
        const { handleStartEdit, immOpenYoungTaxData, handleRemove } = this.props;
        const countryValue = immItem.getIn(['country', 'value']);
        const country = getTranslatedCountry(countryValue);
        const reason = TAXING_REASONS[immItem.getIn(['reason', 'value'])];
        let row;

        if (immItem.get('isEditing')) {
            const immEditableItem = immOpenYoungTaxData.getIn(['editingById', countryValue])
            row = (
                <li
                    className="row no-gutter open-young-tax-data-form__editable-list-item"
                    key={countryValue}
                >
                    {this.buildForm(immEditableItem)}
                </li>
            );
        } else {
            row = (
                <li className="row no-gutter open-young-tax-data-form__list-item" key={countryValue}>
                    <div className="col-xs-12">
                        {country}, {reason}. TIN: {immItem.getIn(['tin', 'value'])}
                        <div className="pull-right open-young-tax-data-form__list-item-buttons">
                            <div className="open-young-tax-data-form__list-item-button">
                                <OKButton modifier="task" onClick={() => handleStartEdit(countryValue)}>
                                    <i className="icon-editar" />
                                </OKButton>
                            </div>
                            <div className="open-young-tax-data-form__list-item-button">
                                <OKButton modifier="task" onClick={() => handleRemove(countryValue)}>
                                    <i className="icon-eliminar" />
                                </OKButton>
                            </div>
                        </div>
                    </div>
                </li>
            );
        }

        return row;
    }

    buildListSection() {
        const { immOpenYoungTaxData } = this.props;
        let listElements = [];
        let formSection;
        let listSection;

        if (immOpenYoungTaxData.getIn(['hasTaxData', 'value'])) {
            const immList = immOpenYoungTaxData.get('byId');
            const addFormVisible = immOpenYoungTaxData.getIn(['editingById', 'new', 'isEditing']);
            const listIsEmpty = immList.size === 0;
            if (!listIsEmpty) {
                immList.forEach(immItem => listElements.push(this.buildListItem(immItem)));

                listSection = (
                    <ul className="open-young-tax-data-form__list">
                        {listElements}
                    </ul>
                );
            }

            if (addFormVisible) {
                formSection = this.buildForm();
            }
        }

        return (
            <section >
                {listSection}
                {formSection}
            </section>
        );
    }

    buildShowFormButton() {
        const { immOpenYoungTaxData, toggleAddForm } = this.props;
        const addFormVisible = immOpenYoungTaxData.getIn(['editingById', 'new', 'isEditing']);
        let button;

        if (!addFormVisible && immOpenYoungTaxData.getIn(['hasTaxData', 'value'])) {
            button = (
                <OKButton
                    leftIcon="icon-agregar"
                    modifier="ghost"
                    onClick={() => toggleAddForm(true)}
                >
                    <FormattedText value="openYoungTaxDataForm-openYoungTaxDataForm_addButton" />
                </OKButton>
            );
        }

        return button;
    }

    buildEditingInProgressWarning() {
        const { immOpenYoungTaxData } = this.props;
        const activeForms = immOpenYoungTaxData.get('editingById').filter(immTaxDataItem => immTaxDataItem.get('isEditing')).size > 0;
        const noData = immOpenYoungTaxData.get('byId').size === 0;
        let messageElement;

        if (immOpenYoungTaxData.getIn(['hasTaxData', 'value']) && immOpenYoungTaxData.get('validatedStep') &&
            (activeForms || noData)) {
            messageElement = (
                <OKMessage type="warning">
                    <FormattedText value="openYoungTaxDataForm-openYoungTaxDataForm_editingInProgressWarning" />
                </OKMessage>
            );
        }

        return messageElement;
    }

    render() {
        const { immOpenYoungTaxData } = this.props;
        const hasObligationsLabel = formatText('openYoungTaxDataForm-openYoungTaxDataForm_hasObligations');
        const noLabel = formatText('openYoungTaxDataForm-openYoungTaxDataForm_no');
        const yesLabel = formatText('openYoungTaxDataForm-openYoungTaxDataForm_yes');
        const listSection = this.buildListSection();
        const showFormButton = this.buildShowFormButton();
        const editingInProgressWarning = this.buildEditingInProgressWarning();

        return (
            <article className="open-young-tax-data-form">
                <div className="row open-young-tax-data-form__radio-button">
                    <div className="col-xs-12">
                        <RadioButtonGroup
                            errorMessage={''}
                            errorState={false}
                            idPrefix="hasTaxData"
                            key="hasTaxData"
                            label={hasObligationsLabel}
                            name="hasTaxData"
                            onChange={this.handleRadioButtonChange}
                            selectedValue={immOpenYoungTaxData.getIn(['hasTaxData', 'value'])}
                            value={immOpenYoungTaxData.getIn(['hasTaxData', 'value'])}
                        >
                            <RadioButton
                                key="openYoungTaxDataForm-openYoungTaxDataForm_no"
                                label={noLabel}
                                value={false}
                            />
                            <RadioButton
                                key="openYoungTaxDataForm-openYoungTaxDataForm_yes"
                                label={yesLabel}
                                value={true}
                            />
                        </RadioButtonGroup>
                    </div>
                    <div className="row no-gutter">
                        {editingInProgressWarning}
                    </div>
                </div>
                {listSection}
                {showFormButton}
            </article>
        );
    }
}

OpenYoungTaxDataForm.propTypes = {
    handleCancel: PropTypes.func.isRequired,
    handleRemove: PropTypes.func.isRequired,
    handleSave: PropTypes.func.isRequired,
    handleStartEdit: PropTypes.func.isRequired,
    handleUpdate: PropTypes.func.isRequired,
    immOpenYoungTaxData: PropTypes.object.isRequired,
    reset: PropTypes.func.isRequired,
    setField: PropTypes.func.isRequired,
    setFormField: PropTypes.func.isRequired,
    toggleAddForm: PropTypes.func.isRequired,
    validateFormField: PropTypes.func.isRequired,
};

module.exports.constructor = OpenYoungTaxDataForm;

module.exports.OpenYoungTaxDataForm = connect(null,
    {
        handleCancel: openYoungTaxDataActions.cancel,
        handleRemove: openYoungTaxDataActions.remove,
        handleSave: openYoungTaxDataActions.validateAndSave,
        handleStartEdit: openYoungTaxDataActions.startEdit,
        handleUpdate: openYoungTaxDataActions.updateById,
        reset: openYoungTaxDataActions.reset,
        setField: openYoungTaxDataActions.setField,
        setFormField: openYoungTaxDataActions.setFormField,
        toggleAddForm: openYoungTaxDataActions.toggleAddForm,
        validateFormField: openYoungTaxDataActions.validateFormField,
    }
)(OpenYoungTaxDataForm);